/**
 * @param {Object} PaymentDA
 * @param {Object} paymentsResolve
 * @constructor
 */
var PaymentsController = function(PaymentDA, paymentsResolve) {
  this.payments_ = paymentsResolve.payments;
  this.PaymentDA_ = PaymentDA;
};

/**
 * @param {Object} payment
 * @returns {String}
 */
PaymentsController.prototype.getInvoiceFile = function(payment) {
  var invoiceUrl = this.PaymentDA_.getInvoiceFilePath(payment._id);

  return invoiceUrl;
};

module.exports = PaymentsController;



// WEBPACK FOOTER //
// ./src/app/modules/payment/PaymentsCtrl.js